export const DATE_REGEX = /^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12]\d|3[01])$/g;
